import http from './httpService';

const apiEndPoint = '/bwallet-types';

function bwalletTypeUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getBitcoinWalletTypes() {
  return http.get(apiEndPoint);
}

export function getBitcoinWalletType(bwalletTypeId) {
  return http.get(bwalletTypeUrl(bwalletTypeId));
}

export function saveBitcoinWalletType(bwalletType) {
  if (bwalletType._id) {
    const body = { ...bwalletType };
    delete body._id;
    return http.put(bwalletTypeUrl(bwalletType._id), body);
  }

  return http.post(apiEndPoint, bwalletType);
}

export function deleteBitcoinWalletType(bwalletTypeId) {
  return http.delete(bwalletTypeUrl(bwalletTypeId));
}
